document.addEventListener('DOMContentLoaded', () => {
  // Find all the product sections
  const productSections = document.querySelectorAll('.js-product-section');

  // Apply the filter logic to each section independently
  productSections.forEach((section) => {
    // Find the elements *inside* this specific section
    const filterContainer = section.querySelector('.js-filter-container');
    const filterButtons = filterContainer.querySelectorAll('.filter-button');
    const contentPanel = section.querySelector('.content-panel');
    const contentItems = contentPanel.querySelectorAll('.content-item');

    const activeClass = section.dataset.activeClass;
    const activeBtnClasses = [activeClass];

    // This function now only controls the 7 buttons and 7 items
    // from its own section.
    function updateDisplay(activeIndex) {
      // Update button states
      filterButtons.forEach((btn) => {
        if (btn.dataset.index === activeIndex) {
          btn.classList.add(...activeBtnClasses);
        } else {
          btn.classList.remove(...activeBtnClasses);
        }
      });

      // Update content visibility
      contentItems.forEach((item) => {
        if (item.dataset.index === activeIndex) {
          item.classList.remove('opacity-0');
          item.classList.add('opacity-100');
        } else {
          item.classList.add('opacity-0');
          item.classList.remove('opacity-100');
        }
      });
    }

    // Set the initial state for *this* section
    // (e.g., '0' for the first, '7' for the second, '14' for the third)
    const initialIndex = filterButtons[0].dataset.index;
    updateDisplay(initialIndex);

    // Add the click listener for *this* section's filter container
    filterContainer.addEventListener('click', (e) => {
      const clickedButton = e.target.closest('.filter-button');
      if (!clickedButton) return;

      const indexToShow = clickedButton.dataset.index;
      updateDisplay(indexToShow);
    });
  });
});